import { ClickEvent, DataSourceExecutionEvent } from "@mcleod/components";
import { AutogenLayoutEdiProfileGenericQuickInfo } from "./autogen/AutogenLayoutEdiProfileGenericQuickInfo";
import { StringUtil } from "@mcleod/core";
import { EdiUtility } from "./EdiUtility";
import { GenericProfile } from "./GenericProfile";

export class EdiProfileGenericQuickInfo extends AutogenLayoutEdiProfileGenericQuickInfo {
    doAfterExecute(event: DataSourceExecutionEvent) {
        if (StringUtil.isEmptyString(this.sourceEdigenericProfile.activeRow?.get("notes"))) {
            this.imagePartnerNotes.enabled = false;
            this.imagePartnerNotes.imageColor = "subtle.light";
            this.imagePartnerNotes.tooltip = "No partner notes available"
        }
    }

    openClassicPartnerProfile(event: ClickEvent): void {
        const id = this.sourceEdigenericProfile?.activeRow?.get("id");
        if (id != null) {
            GenericProfile.navigateTo(id);
        }
    }

    showPartnerNotes() {
        EdiUtility.showPartnerNotes(this.sourceEdigenericProfile.activeRow?.get("id"),
            this.sourceEdigenericProfile.activeRow?.get("partner_name"), this.sourceEdigenericProfile.activeRow?.get("notes"));
    }
}